.tab-list {
  overflow-y: hidden;
}
